export default __webpack_public_path__ + "static/media/pic3.d3e5f674.jpg";